import React, { useState } from 'react';
import { Container, Row, Col, Tabs, Tab, Alert } from 'react-bootstrap';
import UploadForm from './components/UploadForm';
import Preview from './components/Preview';
import CodeView from './components/CodeView';

export default function App() {
  const [result, setResult] = useState({ html: '', filename: '' });
  const [editedHtml, updateHtml] = useState(result.html);

  return (
    <Container className="app-container">
      <Row>
        <Col>
          <h3 className="mb-3">Конвертер Word (.docx) → HTML с формулами</h3>
        </Col>
      </Row>


      <Col >
        <UploadForm onResult={setResult} />
        <Alert variant="info">
          Поддержка: формулы OMML → MathML, таблицы, выделения, заголовки, картинки
        </Alert>
      </Col>
      <hr></hr>
      <Col>
        <Tabs defaultActiveKey="preview" className="mb-3">
          <Tab eventKey="preview" title="Предпросмотр">
            {result.html ? <Preview html={result.html.replace('<style>', '<noscript>').replace('</style>', '</noscript>')} filename={result.filename} setResult={updateHtml} /> : <div>Нет данных для просмотра.</div>}
          </Tab>
          <Tab eventKey="code" title="HTML код">
            {result.html ? <CodeView html={editedHtml} filename={result.filename} /> : <div>Нет кода для отображения.</div>}
          </Tab>
        </Tabs>
      </Col>

    </Container>
  );
}